import { gql, TypedDocumentNode } from "@apollo/client";

import { stackVendorConfigFragment } from "components/form/graphql";
import {
  OpenTofuMigrationQueueEntry,
  QueryOpenTofuMigrateSearchArgs,
  QueryOpenTofuMigrationQueueSearchArgs,
  SearchStacksOutput,
  Stack,
} from "types/generated";

type FetchOpenTofuMigrateSearchData = {
  openTofuMigrateSearch: Pick<SearchStacksOutput, "edges">;
};

export const OPEN_TOFU_MIGRATE_SEARCH: TypedDocumentNode<
  FetchOpenTofuMigrateSearchData,
  QueryOpenTofuMigrateSearchArgs
> = gql`
  query OpenTofuMigrateSearch($input: SearchInput!, $target: StackVendor!) {
    openTofuMigrateSearch(input: $input, target: $target) {
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
`;

type FetchOpenTofuMigrationQueueSearchData = {
  openTofuMigrationQueueSearch: {
    edges: Array<{
      node: Pick<OpenTofuMigrationQueueEntry, "id" | "state" | "note"> & {
        stack: Pick<Stack, "id" | "labels" | "vendorConfig">;
      };
    }>;
  };
};

export const OPEN_TOFU_MIGRATION_QUEUE_SEARCH: TypedDocumentNode<
  FetchOpenTofuMigrationQueueSearchData,
  QueryOpenTofuMigrationQueueSearchArgs
> = gql`
  query OpenTofuMigrationQueueSearch($input: SearchInput!) {
    openTofuMigrationQueueSearch(input: $input) {
      edges {
        node {
          id
          state
          note
          stack {
            id
            labels
            ...stackVendorConfig
          }
        }
      }
    }
  }
  ${stackVendorConfigFragment}
`;
